import { with1ezpy3gn0rpui as with_0 } from '../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/PartyId.mjs';
import { SavePlayerMutation13ci6nh8jmmgu as SavePlayerMutation } from './schema/SavePlayerMutation.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Accepted_instance1051nmidder43 as Accepted_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Dispatcher39hthxqv8voqz as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/SavePlayerCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { toSerializable3fb4aia8ysz5b as toSerializable } from './SdkPairAssignmentDocumentSave.mjs';
import { Companion_instance31yew3aywi0is as Companion_instance } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { SavePlayerInput3s7vno6nbe1ix as SavePlayerInput } from './schema/type/SavePlayerInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_perform__v6ng8j($this, command, $completion) {
  // Inline function 'kotlin.with' call
  var tmp = $this.o6q(new (SavePlayerMutation())(input(with_0(command.y2l_1, command.z2l_1))), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Accepted_instance;
}
function perform(command, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_perform__v6ng8j.bind(VOID, this, command), $completion);
}
var SdkSavePlayerCommandDispatcherClass;
function SdkSavePlayerCommandDispatcher() {
  if (SdkSavePlayerCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkSavePlayerCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkSavePlayerCommandDispatcherClass = $;
  }
  return SdkSavePlayerCommandDispatcherClass;
}
function input(_this__u8e3s4) {
  var tmp = toSerializable(_this__u8e3s4.l2b_1.o2b_1);
  var tmp_0 = Companion_instance.q47(_this__u8e3s4.l2b_1.t2b_1);
  var tmp_1 = Companion_instance;
  var tmp0_safe_receiver = _this__u8e3s4.l2b_1.u2b_1;
  return new (SavePlayerInput())(_this__u8e3s4.k2b_1, _this__u8e3s4.l2b_1.n2b_1, _this__u8e3s4.l2b_1.p2b_1, _this__u8e3s4.l2b_1.q2b_1, tmp, _this__u8e3s4.l2b_1.r2b_1, _this__u8e3s4.l2b_1.s2b_1, tmp_0, tmp_1.q47(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a2_1), toList(_this__u8e3s4.l2b_1.v2b_1));
}
//region block: exports
export {
  SdkSavePlayerCommandDispatcher as SdkSavePlayerCommandDispatcher2k2b5uhezxdlq,
  perform as perform272nir7h51f3q,
};
//endregion

//# sourceMappingURL=SdkSavePlayerCommandDispatcher.mjs.map
